import { useLazyQuery } from '@apollo/react-hooks';
import { AlertsQuery } from './__generated__/AlertsQuery';
import { kmsClient } from 'api';
import { ALERTS_QUERY } from './alerts.query';

export const useAlertsLazyQuery = () => {
  return useLazyQuery<AlertsQuery>(ALERTS_QUERY, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
